// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document {
  width: 100%;
  padding: 20px;
  border: 1px solid #e5e5e5;
}
.document .header-row1 {
  display: flex;
  flex-direction: row;
  margin: auto;
  width: 100%;
}
.document .header-row1 .sender-info {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto auto auto 0;
}
.document .header-row1 .brand {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-weight: bold;
  font-size: 32px;
  margin: auto 0 auto auto;
}
.document .header-row1 .brand .brand-name1 {
  color: #1d0f40;
}
.document .header-row1 .brand .brand-name2 {
  color: #8dc63f;
}
.document .header-row2 {
  display: flex;
  flex-direction: row;
  margin: auto;
  width: 100%;
}
.document .header-row2 .header-col {
  display: flex;
  justify-content: center;
  padding: 20px 0 20px 0;
  margin: auto;
  flex: 1 1;
}
.document .header-row2 .header-col .customer-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto auto auto 0;
}

@media screen and (max-width: 500px) {
  .document .header-row1 .brand {
    display: none;
  }
  .document .header-row2 {
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/purchase-order/purchase-order.styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAEJ;AADI;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AAGN;AAAI;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;AAEN;AADM;EACE,cAAA;AAGR;AADM;EACE,cAAA;AAGR;AACE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AACJ;AACI;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AACN;AACM;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AACR;;AAKA;EAGM;IACE,aAAA;EAJN;EAQE;IACE,sBAAA;IACA,uBAAA;IACA,eAAA;EANJ;AACF","sourcesContent":[".document {\n  width: 100%;\n  padding: 20px;\n  border: 1px solid #e5e5e5;\n  .header-row1 {\n    display: flex;\n    flex-direction: row;\n    margin: auto;\n    width: 100%;\n    .sender-info {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: column;\n      justify-content: flex-start;\n      margin: auto auto auto 0;\n    }\n\n    .brand {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n      font-weight: bold;\n      font-size: 32px;\n      margin: auto 0 auto auto;\n      .brand-name1 {\n        color: #1d0f40;\n      }\n      .brand-name2 {\n        color: #8dc63f;\n      }\n    }\n  }\n  .header-row2 {\n    display: flex;\n    flex-direction: row;\n    margin: auto;\n    width: 100%;\n\n    .header-col {\n      display: flex;\n      justify-content: center;\n      padding: 20px 0 20px 0;\n      margin: auto;\n      flex: 1;\n\n      .customer-info {\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        margin: auto auto auto 0;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .document {\n    .header-row1 {\n      .brand {\n        display: none;\n      }\n    }\n\n    .header-row2 {\n      flex-direction: column;\n      justify-content: center;\n      flex-wrap: wrap;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
